import { Directive, Input, HostListener, ElementRef } from '@angular/core';
import { MenuController } from 'ionic-angular/components/app/menu-controller';

/**
 * Generated class for the CoMenuToggleDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[co-menu-toggle]' // Attribute selector
})
export class CoMenuToggleDirective {
  @Input() menuId: string;
  constructor(private menuCtrl : MenuController, private element: ElementRef) {
  }

  @HostListener('click', ['$event']) onclick(event){
    this.menuCtrl.toggle(this.menuId);
  }

}



// WEBPACK FOOTER //
// ./src/directives/co-menu-toggle/co-menu-toggle.ts